import React from 'react';
import {useFontSizeStore} from "../stores/useFontSizeStore";
import Image from "../assets/logo_2025.jpg";

const Contacts = () => {

  const Mailto = ({ email, subject = '', body = '', children }) => {
    let params = subject || body ? '?' : '';
    if (subject) params += `subject=${encodeURIComponent(subject)}`;
    if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

    return <a href={`mailto:${email}${params}`}>{children}</a>;
  };

  const options = useFontSizeStore(state => state.defs)
  const textSizeSelected = useFontSizeStore(state => state.textSizeSelected)
  const langSelected = useFontSizeStore((state) => state.lang)
  return (
    <div className="container">
      <div className="row">
        <div className="col-8">
          <p style={options[textSizeSelected].styleOver}>{langSelected === 0 ? 'Kontakti' : 'Contacts'}</p>
        </div>
        <div className="col-4">

        </div>
      </div>

      <img src={Image} className="img-fluid" style={{width:'80%', height:'390px', paddingBottom:'20px'}} alt="Contacts" />

      <div className="row mt-1">
        <div className="col-lg-2 col-sm-0">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-6 col-sm-12">
          <p style={options[textSizeSelected].styleNormal}>
            PODUZEĆE ZA PROIZVODNJU, TRGOVINU I USLUGE, EXPORT-IMPORT d.o.o.
          </p>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-lg-2 col-sm-0">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-6 col-sm-12">
          <p style={options[textSizeSelected].styleNormal}>
            FIRM FOR PRODUCTION, TRADING, EXPORT-IMPORT AND SERVICES Ltd.
          </p>
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-lg-2 col-sm-0">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-6 col-sm-12">
          <p style={options[textSizeSelected].styleNormal}>
            HRVATSKA / CROATIA, 40305 NEDELIŠČE, GORČICA 5 
          </p>
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-lg-2 col-sm-0">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-6 col-sm-12">
          <p style={options[textSizeSelected].styleNormal}>
            PHONE 385 40 360 700, FAX 385 40 360 703
          </p>
        </div>
      </div>
      <div className="row mt-1">
      <div className="col-lg-2 col-sm-0">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-6 col-sm-12">
          <p style={options[textSizeSelected].styleNormal}>
            <Mailto email="pinky-s@pinky-s.com" subject="Upit sa web stranice" body="">
              pinky-s@pinky-s.com
            </Mailto>, 
            www.pinky-s.com
          </p>
        </div>
      </div>


      <div className="row mt-5">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            {langSelected === 0 ? 'Direktor:' : 'Director:'}
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Milivoj Koprivec
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7001
          </p>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            {langSelected === 0 ? 'Računovodstvo i financije:' : 'Accounts and finance:'}
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Spomenka Koprivec
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7002
          </p>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            {langSelected === 0 ? 'Laboratorij:' : 'Laboratory:'}
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Danijel Šinko
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7006
          </p>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Nataša Pavlović
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
          <Mailto email="natasa@pinky-s.com" subject="Upit sa web stranice" body="">
                natasa@pinky-s.com
              </Mailto>
          </p>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Tea Kapustić
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7005
          </p>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Eva Zimprich
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7016
          </p>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            {langSelected === 0 ? 'Odjel automatizacije:' : 'Automation Department:'}
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Dejan Kralj
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7009
          </p>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Roko Sabol
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7008
          </p>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
          Tomislav Kovačić
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7007
          </p>
        </div>
      </div>


      <div className="row mt-5">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            {langSelected === 0 ? 'Komercijala:' : 'Commercial Department:'}
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            Ivana Pejić Novak
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7004
          </p>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-lg-3 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>

          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
           David Tomašić
          </p>
        </div>
        <div className="col-lg-2 col-sm-4">
          <p style={options[textSizeSelected].styleNormal}>
            091 \ 360 - 7013
          </p>
        </div>
      </div>

    </div>
  );
};

export default Contacts;
